import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, testid }) => (
  <Reveal className="mb-12 lg:mb-16">
    <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-volt">{eyebrow}</p>
    <h2
      data-testid={testid}
      className="max-w-3xl font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl lg:text-5xl"
    >
      {title}
    </h2>
  </Reveal>
);
